import { EventEmitter } from 'events';
class _AccountWidgetAccountsController {
    constructor() {
        this._Account = null;
        this._eventEmitter = new EventEmitter();
    }
    set Account(account) {
        const prevAcc = this._Account;
        this._Account = account;
        this.OnAccountChangedEmit(account, prevAcc);
    }
    get Account() {
        return this._Account;
    }
    subscribeOnAccountChanged(callback) {
        this._eventEmitter.on('OnAccountChanged', callback);
    }
    unsubscribeOnAccountChanged(callback) {
        this._eventEmitter.off('OnAccountChanged', callback);
    }
    OnAccountChangedEmit(valueN, valueO) {
        this._eventEmitter.emit('OnAccountChanged', valueN, valueO);
    }
    clean() {
        this._Account = null;
    }
}
export const AccountWidgetAccountsController = new _AccountWidgetAccountsController();
